var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeskLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 113,
    viewBox: "0 0 90 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8819 109.333L2.3842 96.0631C-0.750774 94.214 -0.805014 89.5587 2.28597 87.632L11.5713 81.8441C18.6863 77.4091 27.576 77.3536 34.7422 81.6993L57.1807 95.3062C60.3437 97.2242 60.2808 101.976 57.0683 103.804L47.0416 109.509C40.1285 113.442 31.7359 113.375 24.8819 109.333Z",
    fill: "#191E23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8819 108.597L2.3842 95.3277C-0.750774 93.4786 -0.805014 88.8233 2.28597 86.8966L11.5713 81.1088C18.6863 76.6738 27.576 76.6182 34.7422 80.9639L57.1807 94.5708C60.3437 96.4889 60.2808 101.241 57.0683 103.069L47.0416 108.774C40.1285 112.707 31.7359 112.64 24.8819 108.597Z",
    fill: "url(#paint0_linear_2_31912)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.67922 94.7925L25.177 108.062C31.8509 111.999 40.023 112.064 46.7546 108.234L56.7812 102.529C59.5887 100.932 59.6437 96.7786 56.8795 95.1024L34.441 81.4955C27.463 77.2639 18.8068 77.318 11.8787 81.6365L2.59338 87.4244C-0.107884 89.1081 -0.0604853 93.1765 2.67922 94.7925ZM2.3842 95.3277L24.8819 108.597C31.7359 112.64 40.1285 112.707 47.0416 108.774L57.0683 103.069C60.2808 101.241 60.3437 96.4889 57.1807 94.5708L34.7422 80.9639C27.576 76.6182 18.6863 76.6738 11.5713 81.1088L2.28597 86.8966C-0.805014 88.8233 -0.750774 93.4786 2.3842 95.3277Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5601 6.74336C25.5601 5.09233 26.8539 3.75391 28.4499 3.75391H30.6173C32.2133 3.75391 33.5072 5.09233 33.5072 6.74335V92.6899C33.5072 94.341 32.2133 95.6794 30.6173 95.6794H28.4499C26.8539 95.6794 25.5601 94.341 25.5601 92.6899V6.74336Z",
    fill: "url(#paint1_linear_2_31912)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M25.5601 6.74336C25.5601 5.09233 26.8539 3.75391 28.4499 3.75391H30.6173C32.2133 3.75391 33.5072 5.09233 33.5072 6.74335V92.6899C33.5072 94.341 32.2133 95.6794 30.6173 95.6794H28.4499C26.8539 95.6794 25.5601 94.341 25.5601 92.6899V6.74336Z",
    fill: "#171B23"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_2_31912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5072 94.5588C33.5072 95.5907 31.7281 96.4272 29.5336 96.4272C27.3391 96.4272 25.5601 95.5907 25.5601 94.5588C25.5601 93.5269 27.3391 92.6904 29.5336 92.6904C31.7281 92.6904 33.5072 93.5269 33.5072 94.5588Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter1_f_2_31912)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5072 7.8645C33.5072 8.89639 31.7281 9.7329 29.5336 9.7329C27.3391 9.7329 25.5601 8.89639 25.5601 7.8645C25.5601 6.83261 27.3391 5.99609 29.5336 5.99609C31.7281 5.99609 33.5072 6.83261 33.5072 7.8645Z",
    fill: "black"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8428 4.04266C24.8428 1.80996 26.5924 0 28.7508 0H31.6817C33.84 0 35.5897 1.80996 35.5897 4.04266C35.5897 6.27535 33.8401 8.08531 31.6817 8.08531H28.7508C26.5924 8.08531 24.8428 6.27535 24.8428 4.04266Z",
    fill: "#202530"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4256 4.04266C30.4256 6.27535 29.1758 8.08531 27.6342 8.08531C26.0925 8.08531 24.8428 6.27535 24.8428 4.04266C24.8428 1.80996 26.0925 0 27.6342 0C29.1758 0 30.4256 1.80996 30.4256 4.04266Z",
    fill: "#383F4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4485 4.04266C29.4485 6.27535 28.1988 8.08531 26.6571 8.08531C25.1155 8.08531 23.8657 6.27535 23.8657 4.04266C23.8657 1.80996 25.1155 0 26.6571 0C28.1988 0 29.4485 1.80996 29.4485 4.04266Z",
    fill: "#495061"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0431 6.46685C28.4511 5.8759 28.7261 5.0212 28.7261 4.04266C28.7261 3.06412 28.4511 2.20942 28.0431 1.61846C27.634 1.02607 27.1341 0.747362 26.6571 0.747362C26.1802 0.747362 25.6802 1.02607 25.2712 1.61846C24.8632 2.20942 24.5882 3.06412 24.5882 4.04266C24.5882 5.0212 24.8632 5.8759 25.2712 6.46685C25.6802 7.05924 26.1802 7.33795 26.6571 7.33795C27.1341 7.33795 27.634 7.05924 28.0431 6.46685ZM26.6571 8.08531C28.1988 8.08531 29.4485 6.27535 29.4485 4.04266C29.4485 1.80996 28.1988 0 26.6571 0C25.1155 0 23.8657 1.80996 23.8657 4.04266C23.8657 6.27535 25.1155 8.08531 26.6571 8.08531Z",
    fill: "#202736"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5244 0C30.5244 0 30.5312 0 30.6309 0C31.2758 0 31.8851 0.34907 32.2483 1.10051C32.6169 1.86312 32.8396 2.90359 32.8396 4.04266C32.8396 5.18172 32.6169 6.22219 32.2483 6.9848C31.8851 7.73624 31.6822 8.08531 31.0373 8.08531C30.9376 8.08531 30.5244 8.08531 30.5244 8.08531C30.5244 7.98212 30.6053 7.89847 30.705 7.89847C31.1393 7.89847 31.5812 7.5294 31.9252 6.81769C32.2638 6.11715 32.4784 5.13629 32.4784 4.04266C32.4784 2.94902 32.2638 1.96816 31.9252 1.26762C31.5812 0.555909 31.1393 0.18684 30.705 0.18684C30.6053 0.18684 30.5244 0.103189 30.5244 0Z",
    fill: "#383F4E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2872 38.7387L31.5608 8.40218C29.8907 7.38332 30.2552 4.78223 32.1361 4.29578L35.4469 3.43956C36.521 3.16178 37.6571 3.31968 38.6223 3.88087L88.8946 33.1124C90.3961 33.9854 90.3607 36.234 88.8326 37.0561L85.4891 38.8546C84.1629 39.568 82.5749 39.5242 81.2872 38.7387Z",
    fill: "url(#paint2_linear_2_31912)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.725 11.785C35.8265 11.6074 36.0481 11.5486 36.2198 11.6537L79.5676 38.185C79.7393 38.2901 79.7962 38.5193 79.6946 38.6969C79.593 38.8745 79.3714 38.9333 79.1997 38.8282L35.8519 12.2969C35.6802 12.1918 35.6234 11.9626 35.725 11.785Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2_31912",
    x: 21.5601,
    y: 88.6904,
    width: 15.947,
    height: 11.7363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2_31912"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_2_31912",
    x: 21.5601,
    y: 1.99609,
    width: 15.947,
    height: 11.7363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_2_31912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_31912",
    x1: 23.115,
    y1: 79.062,
    x2: 30.3253,
    y2: 115.013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#49525C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2_31912",
    x1: 33.5072,
    y1: 49.343,
    x2: 25.5601,
    y2: 49.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#323A4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.523914,
    stopColor: "#62697C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2_31912",
    x1: 64.2117,
    y1: 17.9542,
    x2: 59.276,
    y2: 26.0287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#474F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.491362,
    stopColor: "#697084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#20232A"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskLight);
export default __webpack_public_path__ + "static/media/DeskLight.4ddcb2d88559a6389c6cf6d114a54ea5.svg";
export { ForwardRef as ReactComponent };